import { render, staticRenderFns } from "./reportsList.vue?vue&type=template&id=5a68c07d&scoped=true&"
import script from "./reportsList.vue?vue&type=script&lang=js&"
export * from "./reportsList.vue?vue&type=script&lang=js&"
import style0 from "./reportsList.vue?vue&type=style&index=0&id=5a68c07d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a68c07d",
  null
  
)

export default component.exports